// Wrapper for react-hot-toast to maintain compatibility with existing code
import toast from 'react-hot-toast';

export interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
  duration?: number;
}

// Hook that returns a toast function compatible with the old API
export function useToast() {
  return {
    toast: ({ title, description, variant, duration = 4000 }: ToastOptions) => {
      // Combine title and description into a message
      let message = '';
      if (title && description) {
        message = `${title}\n${description}`;
      } else {
        message = title || description || '';
      }
      
      // Auto-detect variant from title if not specified
      if (!variant) {
        const titleLower = (title || '').toLowerCase();
        if (titleLower.includes('success') || titleLower === 'success') {
          variant = 'success';
        } else if (titleLower.includes('error') || titleLower.includes('fail') || titleLower === 'error') {
          variant = 'destructive';
        }
      }
      
      // Use react-hot-toast based on variant
      switch (variant) {
        case 'destructive':
          return toast.error(message, { duration });
        case 'success':
          return toast.success(message, { duration });
        default:
          return toast(message, { duration });
      }
    },
  };
}

// Export toast directly for convenience (can be used as toast.success(), toast.error(), etc.)
export { toast };
